type Props = {
  width?: string;
  height?: string;
  viewBox?: string;
  strokeColor?: string;
};

const EditSparkleIcon = (props: Props) => {
  const {
    width = '19',
    height = '20',
    viewBox = '0 0 19 20',
    strokeColor = '#17C964',
  } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
    >
      <path
        d="M9.40147 18.227L5.42188 18.5719L5.76677 14.5923L14.0443 6.36786C14.1679 6.24152 14.3154 6.14113 14.4783 6.07259C14.6411 6.00405 14.8161 5.96875 14.9928 5.96875C15.1695 5.96875 15.3444 6.00405 15.5073 6.07259C15.6702 6.14113 15.8177 6.24152 15.9412 6.36786L17.6259 8.06582C17.7502 8.18915 17.8489 8.33586 17.9163 8.49752C17.9837 8.65917 18.0183 8.83254 18.0183 9.00766C18.0183 9.18277 17.9837 9.35617 17.9163 9.51782C17.8489 9.67947 17.7502 9.82618 17.6259 9.9495L9.40147 18.227Z"
        stroke={strokeColor}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.33058 5.98347C0.865066 5.90247 0.865066 5.2342 1.33058 5.15322C3.01708 4.8598 4.35845 3.57524 4.72451 1.90302L4.75257 1.77483C4.85328 1.31475 5.50839 1.31189 5.61312 1.77107L5.64718 1.92045C6.0268 3.5848 7.36853 4.8585 9.05034 5.1511C9.51824 5.23249 9.51824 5.90418 9.05034 5.98558C7.36853 6.27817 6.0268 7.55188 5.64718 9.21622L5.61312 9.3656C5.50839 9.8248 4.85328 9.82193 4.75257 9.36184L4.72451 9.23367C4.35845 7.56143 3.01708 6.27687 1.33058 5.98347Z"
        stroke={strokeColor}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default EditSparkleIcon;
